import { convert } from 'html-to-text'

import { markdownToHtml } from './markdownToHtml'

// Plain sentences come back from the markdown pipeline unchanged, yet cost almost a millisecond each, which adds up in
// tables that show a text per cell
const plainSentencePattern = /^[A-Za-z0-9À-ÖØ-öø-ÿ€$§%.,:;?!'"()/–-]+(?: [A-Za-z0-9À-ÖØ-öø-ÿ€$§%.,:;?!'"()/–-]+)*$/
const listMarkerPattern = /^(?:[-+]|\d+[.)])/

export const markdownToPlainText = (markdown: string) => {
    if (plainSentencePattern.test(markdown) && !listMarkerPattern.test(markdown)) {
        return markdown
    }

    return convert(markdownToHtml(markdown), {
        wordwrap: false,
        selectors: [
            { selector: 'h1', options: { uppercase: false } },
            { selector: 'h2', options: { uppercase: false } },
            { selector: 'h3', options: { uppercase: false } },
            { selector: 'h4', options: { uppercase: false } },
            { selector: 'h5', options: { uppercase: false } },
            { selector: 'h6', options: { uppercase: false } },
            { selector: 'a', options: { ignoreHref: true } },
            { selector: 'img', format: 'skip' },
            { selector: 'ul', options: { itemPrefix: '• ' } },
        ],
    })
        .replace(/^[ \t]+(?=(?:•|\d+[.)]) )/gm, '')
        .replace(/\n{3,}/g, '\n\n')
        .trim()
}
